import { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import get from 'lodash/get';
import { useDriveStore } from '../drive/DriveStore';
import { useStartupDriveStore } from '../startup-app/StartupDriveStore';
import { getDMSProxyFirewallUrl } from '../../util/getDMSProxyUrls';
import { driveLaunchFallback } from '../../util/driveLaunchFallback';
import userProfileStore from '../core/UserProfileStore';
import { MultipleDMSDialog } from '../drive/MultipleDMSDialog';
import { canOpenDrive } from '../drive/DriveApplicationCard';

function getDmsMappingWithName(cNumbers: string[], dmsMapping: any) {
  if (!cNumbers || !dmsMapping || !dmsMapping.dmsBoxMappings) return [];
  return cNumbers.map((cNumber: string) => {
    const dmsBoxAliasName = dmsMapping?.dmsBoxMappings
      .find((eachBoxDetails: any) =>
        (eachBoxDetails?.cnumber as string).toLowerCase() === cNumber.toLowerCase()
      )?.alias || '';
    return {
      'data-testid': cNumber,
      label: `${cNumber} ${dmsBoxAliasName && `- ${dmsBoxAliasName}`}`,
      value: cNumber,
      link: `https://${cNumber}-dms.drive.connectcdk.com/apps/autoTools/cds/osd/osd.php`,
      dmsBoxAliasName: dmsBoxAliasName?.toLowerCase(),
    };
  });
}

export default function StartupDriveLauncher() {
  const session = useOktaAuth();
  const authToken = get(session, 'authState.idToken.idToken', '');
  const { cNumbers, dmsMapping } = useDriveStore();
  const locale = userProfileStore((state: any) => state.locale);
  const shouldLaunchDrive = useStartupDriveStore((state) => state.shouldLaunchDrive);
  const setShouldLaunchDrive = useStartupDriveStore((state) => state.setShouldLaunchDrive);
  const [showMultiDMSDialog, setShowMultiDMSDialog] = useState(false);

  const { url } = getDMSProxyFirewallUrl({
    cNumber: cNumbers[0],
    driveToken: authToken,
    lang: locale,
  });

  const dmsDataWithName = getDmsMappingWithName(cNumbers, dmsMapping);

  useEffect(() => {
    if (!shouldLaunchDrive) return;
    if (!cNumbers?.length || !url) return;

    setShouldLaunchDrive(false);
    if (!canOpenDrive()) return; 

    if (cNumbers.length > 1) {
      console.log('StartupDriveLauncher: multi-DMS, opening dialog');
      setShowMultiDMSDialog(true);
      return;
    }

    console.log('StartupDriveLauncher: launching Drive');
    driveLaunchFallback(url);
  }, [shouldLaunchDrive, cNumbers, url, setShouldLaunchDrive]);

  return (
    <>
      {showMultiDMSDialog && (
        <MultipleDMSDialog
          setDialogOpen={setShowMultiDMSDialog}
          shouldDialogOpen={showMultiDMSDialog}
          dmsDataWithName={dmsDataWithName}
        />
      )}
    </>
  );
}